import { UsuarioPF, UsuarioPJ } from '@vabembarqueja/embarque-ja-shared-components';

import { APIResponse } from '../models/ApiResponse.model';
import { SituacaoTour } from '../models/Tour.model';
import { UsuarioConta, UsuarioPosPagoState } from '../models/Usuario';

import Service from './Service';

class UsuarioService extends Service {
  static async finalizarTour(situacao: SituacaoTour.Concluido | SituacaoTour.Dispensado) {
    return this.Http.put('/usuario/tour', { situacao });
  }

  static async buscarConta() {
    return this.Http.get<APIResponse<UsuarioConta>>('/usuario/conta')
      .then(this.getData)
      .then((resp) => resp.data);
  }

  static async ativo() {
    return this.Http.get<APIResponse<{ cadastrado: boolean }>>('/usuario/ativo')
      .then(this.getData)
      .then((resp) => resp.data);
  }

  static async alterarPF(data: UsuarioPF) {
    return this.Http.put('/usuario/pessoa-fisica', data);
  }

  static async cadastrarPF(data: UsuarioPF) {
    return this.Http.post('/usuario/pessoa-fisica', data);
  }

  static async alterarPJ(data: UsuarioPJ) {
    return this.Http.put('/usuario/pessoa-juridica', data);
  }

  static async cadastrarPJ(data: UsuarioPJ) {
    return this.Http.post('/usuario/pessoa-juridica', data);
  }

  static async getTipoUsuarioPosPago() {
    return this.Http.get<APIResponse<UsuarioPosPagoState>>('/usuario/pos-pago')
      .then(this.getData)
      .then((resp) => resp.data);
  }

  static async solicitarMigracao(file?: File) {
    const formData = new FormData();
    if (file) {
      formData.append('arquivoMinuta', file);
    }

    return this.Http.put('/usuario/pessoa-juridica/migrar-pos-pago', formData);
  }

  static async adicionarAditivo(file?: File) {
    const formData = new FormData();
    if (file) {
      formData.append('arquivoAditivo', file);
    }

    return this.Http.put('/usuario/pessoa-juridica/adicionar-aditivo', formData);
  }
}

export default UsuarioService;
